module.exports = __webpack_public_path__ + "img/Banner-Limit-Pinjaman.e0e590bc.webp";